// extracted by mini-css-extract-plugin
export default {"sharedDatasetDetailsTabsContainer":"SharedDatasetDetailsTabs_sharedDatasetDetailsTabsContainer__3oxc7","tabsContainer":"SharedDatasetDetailsTabs_tabsContainer__2Dwa-"};